import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MaterialResource\MaterialResourceIndexController::__invoke
* @see app/Http/Controllers/MaterialResource/MaterialResourceIndexController.php
* @route '/api/material-resource'
*/
const MaterialResourceIndexController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: MaterialResourceIndexController.url(options),
    method: 'get',
})

MaterialResourceIndexController.definition = {
    methods: ["get","head"],
    url: '/api/material-resource',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MaterialResource\MaterialResourceIndexController::__invoke
* @see app/Http/Controllers/MaterialResource/MaterialResourceIndexController.php
* @route '/api/material-resource'
*/
MaterialResourceIndexController.url = (options?: RouteQueryOptions) => {
    return MaterialResourceIndexController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MaterialResource\MaterialResourceIndexController::__invoke
* @see app/Http/Controllers/MaterialResource/MaterialResourceIndexController.php
* @route '/api/material-resource'
*/
MaterialResourceIndexController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: MaterialResourceIndexController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MaterialResource\MaterialResourceIndexController::__invoke
* @see app/Http/Controllers/MaterialResource/MaterialResourceIndexController.php
* @route '/api/material-resource'
*/
MaterialResourceIndexController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: MaterialResourceIndexController.url(options),
    method: 'head',
})

export default MaterialResourceIndexController